<template>
  <VDatePicker
    ref="picker"
    v-model="date"
    mode="date"
    title-position="left"
    borderless
    locale="fr"
    :min-date="new Date()"
    :disabled-dates="disabledDates"
    class="pouet"
    @update:model-value="onModelUpdate"
  />
</template>

<script setup lang="ts">
import { ref } from 'vue'

const props = defineProps({
  path: {
    type: String,
    default: '',
  },
})

const date = ref(new Date())
const disabledDates = ref([
  {
    repeat: {
      weekdays: [1],
    },
  },
])

// Emits
const emit = defineEmits(['emitDate'])

// Event handling
const onModelUpdate = (value: Date) => {
  emit('emitDate', props.path, value)
}
</script>

<style lang="scss">
.pouet {
  width: 100%;
  max-width: 47rem;

  .vc-title {
    padding: 0;
    text-transform: capitalize;
    background-color: transparent;
  }

  .vc-weeks {
    padding-top: $spacing;
  }

  .vc-week {
    &:last-of-type {
      border-bottom: 1px solid $c-grey-light;
    }
  }

  .vc-day {
    border-top: 1px solid $c-grey-light;
    border-left: 1px solid $c-grey-light;
    aspect-ratio: 1;

    &:last-child {
      border-right: 1px solid $c-grey-light;
    }
  }

  .vc-day-content {
    width: 100%;
    height: 100%;
    border-radius: 0;
  }

  .vc-highlights {
    background-color: $c-green-abr;
  }

  .vc-disabled {
    color: $c-gray-darker;
    background-color: rgba($c-black, 5%);
  }

  .vc-highlight-bg-solid {
    background-color: transparent;
  }
}
</style>
